import React from 'react';

import { Button } from '@/components/shadcn/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/shadcn/ui/dialog';
import { useGlobalSettingsStore } from '@/shared';

import { BuildDetailsChainTokenInfo } from './BuildDetailsChainTokenInfo/BuildDetailsChainTokenInfo';
import BuildDetailsInfo from './BuildDetailsInfo';
import BuildDetailsInfoContractModules from './BuildDetailsInfoContractModules';
import BuildDetailsCopyIdsAll from './components/BuildDetailsCopyIdsAll';
import { useDistinctTokensChains } from './hooks/useDistinctTokensChains';

const BuildDetails: React.FC = () => {
  const { isVersionInfoVisible, setUiSettings } = useGlobalSettingsStore();
  const chains = useDistinctTokensChains();

  return (
    <Dialog open={isVersionInfoVisible} onOpenChange={(isOpen) => setUiSettings({ isVersionInfoVisible: isOpen })}>
      <DialogContent
        hideClose
        onInteractOutside={(e) => {
          e.preventDefault();
          setUiSettings({ isVersionInfoVisible: false });
        }}
        className="box-border max-h-[calc(100vh-10%)] gap-2 overflow-auto"
      >
        <DialogHeader>
          <DialogTitle>Build information</DialogTitle>
          <DialogDescription>Information about the current contracts and running version</DialogDescription>
        </DialogHeader>

        <BuildDetailsInfo />

        <BuildDetailsInfoContractModules />

        <div className="flex flex-col gap-0.5">
          {chains.map((chain) => {
            return <BuildDetailsChainTokenInfo key={`${chain.chainSlug}-${chain.chainData?.name}`} chain={chain} />;
          })}
        </div>

        <DialogFooter className="flex-col">
          <BuildDetailsCopyIdsAll />
          <DialogClose asChild>
            <Button variant="secondary">Close</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BuildDetails;
